import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoddessBodysuitLanding } from "./pages/GoddessBodysuitLanding";
import { SuccessPage } from "./pages/SuccessPage";
import { FAQPage } from "./pages/FAQPage";
import { ShippingPage } from "./pages/ShippingPage";
import { ReturnsPage } from "./pages/ReturnsPage";
import { SizeGuidePage } from "./pages/SizeGuidePage";
import { ContactPage } from "./pages/ContactPage";
import { AboutPage } from "./pages/AboutPage";
import { OpenBustFajaPage } from "./pages/OpenBustFajaPage";
import { BundlePage } from "./pages/BundlePage";
import { BlogIndexPage } from "./pages/BlogIndexPage";
import { BlogFajaVsShapewearPage } from "./pages/BlogFajaVsShapewearPage";
import { BlogFajaSizeGuidePage } from "./pages/BlogFajaSizeGuidePage";
import { BlogFajaWearTimePage } from "./pages/BlogFajaWearTimePage";
import { BlogOpenBustVsFullBodyPage } from "./pages/BlogOpenBustVsFullBodyPage";
import { BlogFajaVsSpanxVsSkimsPage } from "./pages/BlogFajaVsSpanxVsSkimsPage";
import { BlogHowToWashFajaPage } from "./pages/BlogHowToWashFajaPage";
import { BlogBestFajaForWeddingPage } from "./pages/BlogBestFajaForWeddingPage";
import { BlogPostpartumFajaPage } from "./pages/BlogPostpartumFajaPage";
import { BlogOneFajaFiveOutfitsPage } from "./pages/BlogOneFajaFiveOutfitsPage";
import { BlogInsideAFajaPage } from "./pages/BlogInsideAFajaPage";
import { BlogFajaUnderJeansPage } from "./pages/BlogFajaUnderJeansPage";
import { BlogFajaBackPainPage } from "./pages/BlogFajaBackPainPage";
import { BlogFajaBodyTypePage } from "./pages/BlogFajaBodyTypePage";
import { BlogFajaVsWaistTrainerPage } from "./pages/BlogFajaVsWaistTrainerPage";
import { BlogHowToPutOnFajaPage } from "./pages/BlogHowToPutOnFajaPage";
import { BlogFajaForTravelPage } from "./pages/BlogFajaForTravelPage";
import { BlogReal30DayResultsPage } from "./pages/BlogReal30DayResultsPage";
import { BlogCanYouSleepInFajaPage } from "./pages/BlogCanYouSleepInFajaPage";
import { BlogFajaHistoryPage } from "./pages/BlogFajaHistoryPage";
import { BlogUnderBodyconDressPage } from "./pages/BlogUnderBodyconDressPage";
import { BlogFajaForBloatingPage } from "./pages/BlogFajaForBloatingPage";
import { BlogFajaRollsUpFixPage } from "./pages/BlogFajaRollsUpFixPage";
import { BlogBlackVsNudeFajaPage } from "./pages/BlogBlackVsNudeFajaPage";
import { BlogFirstWeekFajaPage } from "./pages/BlogFirstWeekFajaPage";
import { NewToShapewearPage } from "./pages/NewToShapewearPage";
import { BoyshortsPage } from "./pages/BoyshortsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BundlePage />} />
          <Route path="/bundle" element={<BundlePage />} />
          <Route path="/full-body-faja" element={<GoddessBodysuitLanding />} />
          <Route path="/new-to-shapewear" element={<NewToShapewearPage />} />
          <Route path="/boyshorts" element={<BoyshortsPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/returns" element={<ReturnsPage />} />
          <Route path="/size-guide" element={<SizeGuidePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/open-bust-faja" element={<OpenBustFajaPage />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/faja-vs-shapewear-difference" element={<BlogFajaVsShapewearPage />} />
          <Route path="/blog/how-to-measure-for-a-faja" element={<BlogFajaSizeGuidePage />} />
          <Route path="/blog/how-long-to-wear-a-faja" element={<BlogFajaWearTimePage />} />
          <Route path="/blog/open-bust-vs-full-body-faja" element={<BlogOpenBustVsFullBodyPage />} />
          <Route path="/blog/faja-vs-spanx-vs-skims" element={<BlogFajaVsSpanxVsSkimsPage />} />
          <Route path="/blog/how-to-wash-a-faja" element={<BlogHowToWashFajaPage />} />
          <Route path="/blog/best-faja-for-wedding" element={<BlogBestFajaForWeddingPage />} />
          <Route path="/blog/postpartum-faja-truth" element={<BlogPostpartumFajaPage />} />
          <Route path="/blog/one-faja-five-outfits" element={<BlogOneFajaFiveOutfitsPage />} />
          <Route path="/blog/inside-a-faja-colombiana" element={<BlogInsideAFajaPage />} />
          <Route path="/blog/wearing-faja-under-jeans" element={<BlogFajaUnderJeansPage />} />
          <Route path="/blog/faja-back-pain" element={<BlogFajaBackPainPage />} />
          <Route path="/blog/faja-sizing-body-type" element={<BlogFajaBodyTypePage />} />
          <Route path="/blog/faja-vs-waist-trainer" element={<BlogFajaVsWaistTrainerPage />} />
          <Route path="/blog/how-to-put-on-a-faja" element={<BlogHowToPutOnFajaPage />} />
          <Route path="/blog/faja-for-travel" element={<BlogFajaForTravelPage />} />
          <Route path="/blog/real-customer-30-day-faja-results" element={<BlogReal30DayResultsPage />} />
          <Route path="/blog/can-you-sleep-in-a-faja" element={<BlogCanYouSleepInFajaPage />} />
          <Route path="/blog/history-of-fajas-colombianas" element={<BlogFajaHistoryPage />} />
          <Route path="/blog/what-to-wear-under-bodycon-dress" element={<BlogUnderBodyconDressPage />} />
          <Route path="/blog/faja-for-bloating" element={<BlogFajaForBloatingPage />} />
          <Route path="/blog/faja-rolls-up-fix" element={<BlogFajaRollsUpFixPage />} />
          <Route path="/blog/black-vs-nude-faja-color" element={<BlogBlackVsNudeFajaPage />} />
          <Route path="/blog/first-week-in-a-faja" element={<BlogFirstWeekFajaPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
